<div>
  <p [innerText]="data.text"></p>
  @if (data.team.ownPermissions?.MANAGE_TEAM) {
    @if (data.team.plan.paidPlan) {
      <p>
        Contact sales to upgrade your plan:
        <a [href]="'mailto:' + salesEmailAddress" style="white-space: nowrap">
          {{ salesEmailAddress }}
        </a>
      </p>
    } @else {
      <p>Upgrade your plan before continuing.</p>
    }
  } @else {
    <p>Contact your team administrator to upgrade your plan.</p>
  }
</div>
<div class="flex items-center justify-end gap-2 mt-4">
  <p-button severity="secondary" (click)="close()" type="button">
    Close
  </p-button>
  @if (data.team.ownPermissions?.MANAGE_TEAM && !data.team.plan.paidPlan) {
    <a pButton [href]="upgradeUrl" [pAutoFocus]="true">
      <i pButtonIcon class="{{ PrimeIcons.STAR }}"></i>
      <span pButtonLabel>Upgrade</span>
    </a>
  }
</div>
